import { render, staticRenderFns } from "./AirportHotels.vue?vue&type=template&id=63c32f77&scoped=true&"
import script from "./AirportHotels.vue?vue&type=script&lang=js&"
export * from "./AirportHotels.vue?vue&type=script&lang=js&"
import style0 from "./AirportHotels.vue?vue&type=style&index=0&id=63c32f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c32f77",
  null
  
)

export default component.exports